import React, { useRef } from 'react'
import css from '../css/Header.css'
import { doc } from '../firebase'
import hamBurger from '../images/hamburger.png'
import Fade from 'react-reveal/Fade'
import { Link,useLocation } from 'react-router-dom'


function Header() {

    const navbarRightARef = useRef();
    const hamBurgerRef = useRef();
    
    const location = useLocation();

    


    return (
        <div>
            <nav className='navbar'>
                <div className='navbarLeft'>
                    <li><a href="/">devUnais</a></li>
                </div>

                {location.pathname != "/projects" ?

                    <div className='navbarRight'>
                        <img ref={hamBurgerRef} src={hamBurger} onClick={() => {

                            if (navbarRightARef.current.className == 'navbarRightA') {
                                navbarRightARef.current.style.animationName = "";
                                navbarRightARef.current.style.animationDuration = '';

                                navbarRightARef.current.className = "navbarRightAMedia";
                                hamBurgerRef.current.className = "hamBurgerMedia";

                            }
                            else {
                                navbarRightARef.current.style.animationName = "navbarRightUpAnim";
                                navbarRightARef.current.style.animationDuration = '0.5s';


                                setTimeout(() => {
                                    navbarRightARef.current.className = "navbarRightA";
                                    hamBurgerRef.current.className = "";

                                }, 500);

                            }
                        }} alt="" srcset="" />




                        <div ref={navbarRightARef} className='navbarRightA'>
                            <li><Link to="/projects">Projects</Link></li>
                            <li><a href="https://github.com/devUnais" target="_blank">Github</a></li>
                            <li><a href="#aboutMe">About Me</a></li>
                            <li><a href="#contact">Contact Me</a></li>
                        </div>




                    </div>
                    
                    : ''
                }

            </nav>
        </div>
    )
}

export default Header
